var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { giveawaySectionStyles, } from 'root/src/client/web/giveaway/features/GiveawaySection/styles/giveawayStyles';
import { useCreatorActiveGiveaway, useGiveawayTerms, } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { useGiveawayApi } from 'root/src/client/web/giveaway/hooks/useGiveawayApi';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { useGiveawaySection, } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { useBetween } from 'use-between';
import { useGiveawayTermsCheckbox, } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTermsCheckbox';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { GiveawayTermsCheckbox, VerificationSection, } from 'root/src/client/web/giveaway/features/GiveawaySection/ViewerGiveawaySection';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { ActionStrategyId } from '@daredrop-com/rewards-api-contract';
import { useAuthModals } from 'root/src/client/web/auth/hooks/useAuthModals';
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useEnterGiveawayApi } from 'root/src/client/web/giveaway/hooks/useEnterGiveawayApi';
import { useBrowserNotification } from 'root/src/client/v2/common/hooks/useBrowserNotification';
export const useEnterGiveawayButton = () => {
    const classes = giveawaySectionStyles();
    const { onGiveawayTermsAccept, isAuthenticated } = useGiveawaySection();
    const { displaySignInModal } = useAuthModals();
    const giveaway = useCreatorActiveGiveaway();
    const creatorDataApi = useCreatorDataApi();
    const giveawayApi = useGiveawayApi();
    const giveawayTerms = useGiveawayTerms();
    const { isGiveawayTermsCheckboxSelected } = useBetween(useGiveawayTermsCheckbox);
    const [isLoading, setIsLoading] = useState(false);
    const modal = useModal();
    const { enterGiveaway } = useEnterGiveawayApi();
    const { requestPermission } = useBrowserNotification();
    const onSMSVerify = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!giveaway) {
            toast.error('Giveaway not found, refresh the page and try again.');
            return;
        }
        const smsAction = giveaway.actions.find(a => a.strategyId === ActionStrategyId.EnterGiveawayVerifySms);
        if (!smsAction) {
            toast.error('SMS verification was not configured for this giveaway.');
            return;
        }
        yield onGiveawayTermsAccept();
        const smsEntry = yield giveawayApi.createEntry({
            actionId: smsAction.id,
            giveawayId: giveaway.id,
            strategyId: ActionStrategyId.EnterGiveawayVerifySms,
        });
        if (!smsEntry || smsEntry.error) {
            const message = getErrorMessage(smsEntry === null || smsEntry === void 0 ? void 0 : smsEntry.error) || 'Failed to submit SMS verification entry.';
            toast.error(message);
            return;
        }
        const giveawayEntry = yield giveawayApi.enterGiveaway({
            giveawayId: giveaway.id,
        });
        if (!giveawayEntry || giveawayEntry.error) {
            const message = getErrorMessage(giveawayEntry.error) || 'Failed to enter giveaway after SMS verification.';
            toast.error(message);
            return;
        }
        yield creatorDataApi.fetchGiveaways();
        modal.hide();
        toast.success('Successfully entered the giveaway!');
    });
    const VerificationModal = () => {
        return (<ModalLayout className="gap-4 justify-start sm:min-w-[600px] sm:max-w-[600px] min-h-[440px]">
				<div className="flex flex-col pt-6 gap-4">
					<ModalTitle>Oops, one more step!</ModalTitle>
					<p className="border-l-2 border-l-placeholder p-3 bg-[rgba(100,100,100,.3)] text-white text-sm">
						We use verification to prevent giveaway fraud and ensure fair participation.
						This helps us maintain a trustworthy community and provide equal opportunities for all participants.
						This is a one-time process.
					</p>
					<div className="flex flex-initial flex-col justify-center items-center gap-4 w-full">
						<VerificationSection onSuccess={onSMSVerify}/>
						<GiveawayTermsCheckbox />
					</div>
				</div>
			</ModalLayout>);
    };
    const onEnterGiveaway = (props = {}) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isAuthenticated) {
            displaySignInModal();
            return;
        }
        if ((!isGiveawayTermsCheckboxSelected && !giveawayTerms) || !canEnter) {
            modal.show(<VerificationModal />);
            return;
        }
        yield onGiveawayTermsAccept();
        setIsLoading(true);
        try {
            yield enterGiveaway();
            void requestPermission();
            if (props.onSuccess) {
                props.onSuccess();
            }
        }
        catch (err) {
            console.error(err);
            const message = err instanceof Error ? err.message : 'Failed to enter giveaway';
            toast.error(message, {
                style: {
                    backgroundColor: colorsNew.pink,
                    color: colorsNew.white,
                },
            });
        }
        setIsLoading(false);
    });
    const canEnter = giveaway && (giveaway.isSteamEntered || giveaway.isSMSEntered);
    return {
        onEnterGiveaway,
        isLoading,
        classes,
        isSteamEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSteamEntered),
        isSMSEntered: Boolean(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSMSEntered),
        canEnter,
    };
};
